import { API_ENDPOINT } from 'src/config/env.config';
import { baseApi } from './axios';
import { BaseAPIResponse, GitHubContributionsAPIResponse } from 'types';

const baseUrl = `${API_ENDPOINT}/github`;

export const connectGitHub = async (): Promise<BaseAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}`);
	return response.data;
};

export const getGitHubContributions = async (userId: string): Promise<GitHubContributionsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/get-contributions/${userId}`);
	return response.data;
};
